import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, FormParser, PopupModal } from "../Components";
import Masters from "../Components/masters.json";
import axiosConfig from "../Service/axiosConfig";
import DataTable from "react-data-table-component";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { SettingNavbarComponent } from "../Components/navbar/settingsnav";
import { Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { FaHandHoldingHeart } from "react-icons/fa";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";

const AdminProfile = () => {
  const [Loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [deletePopupType, setDeletepopupType] = useState("")
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [RowId, SetRowId] = useState()
  const [stores, setStores] = useState([]);
  const [search, SetSearch] = useState({
    search: "",
  });
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({});
  const [modalTitle, setModalTitle] = useState("Add New Store");
  const [popupType, setpopupType] = useState("");
  const [Error, SetError] = useState("");
  const [message, setMessage] = useState("");
  const ecommerce_type = JSON.parse(
    localStorage.getItem("site_data")
  ).ecommerce_type;

  function CancelAlerrt() {
    SetAlertDeletePopupType("error")
  }

  async function HandleDelete(id) {
    try {
      await axiosConfig.delete(`/stores/stores/${id}/`)
        .then(() => {
          SetAlertDeletePopupType("error")
          setDeletepopupType("success")
        })
      GetStores();
    } catch (error) {
      SetAlertDeletePopupType("error")
    }
  }
  const store_columns = [
    {
      name: "ID",
      selector: "id",
      sortable: true,
      width: "150px",
      reorder: true
    },
    {
      name: "Name",
      selector: "name",
      sortable: true,
      width: "150px",
      reorder: true
    },
    {
      name: "Code",
      selector: "code",
      sortable: true,
      width: "100px",
      reorder: true
    },
    {
      name: "Logo",
      reorder: true,
      cell: (row) => (
        <img
          src={row.logo_image ? row.logo_image.image : ""}
          alt={row.name}
          style={{ width: "50px" }}
        />
      ),
      width: "100px",
    },
    {
      name: "Banner",
      reorder: true,
      cell: (row) => (
        <img
          src={row.banner_image ? row.banner_image.image : ""}
          alt={row.name}
          style={{ width: "100px" }}
        />
      ),
      width: "140px",
    },
    {
      name: "Address",
      selector: "address",
      sortable: true,
      width: "400px",
      reorder: true
    },
    {
      name: "Actions",
      reorder: true,
      width: "240px",
      cell: (row) => {
        const handleEdit = async (id) => {
          setModalTitle("Edit Store");
          setShow(true);
          try {
            const response = await axiosConfig.get(`/stores/stores/${id}/`);
            setFormData(response.data);
          } catch (error) {
            console.log(error);
          }
        };

        function deleteAlert(id) {
          SetRowId(id)
          SetAlertDeletePopupType("success")
        }



        const handleRevive = async (id) => {
          try {
            await axiosConfig.post(`/stores/stores/${id}/revive/`)
              .then(() => {
                setpopupType("success")
                setMessage("Product revive successfully")
              })
            GetStores();
          } catch (error) {
            console.log(error)
          }
        }
        return (
          <>
            {
              !row.is_suspended ?
                (
                  <div>
                    <div className="table-actions">
                      <button className="action-btn edit-btn" onClick={() => handleEdit(row.id)} >
                        <MdOutlineEdit /> Edit
                      </button>

                      <button className="action-btn delete-btn" onClick={() => deleteAlert(row.id)} >
                        <MdDeleteOutline /> Delete
                      </button>
                    </div>
                  </div>
                ) :
                (
                  <>
                    <FaHandHoldingHeart onClick={() => handleRevive(row.id)} />
                  </>
                )
            }

          </>

        )
      },
    },
  ];

  const GetStores = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get(
        `/stores/stores/?page=${currentPage}&page_size=${RowPerPage}`
      );
      setStores(responce.data.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };

  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
    axiosConfig
      .get(`/stores/stores/?search=${value}`)
      .then((res) => {
        setStores(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `/stores/stores/?ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        setStores(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };

  const handleClose = () => {
    setShow(false);
    SetError("");
    setpopupType("");
  };



  const handleAdd = () => {
    setShow(true);
    setModalTitle("Add New Store");
    setFormData({ is_online: "online" });
    SetError("");
    setpopupType("");
  };

  const formSubmit = (Data) => {
    console.log(Data);
    const coordsArray =
      Data.polygon && Data.polygon.length >= 3
        ? Data.polygon
        : Data.polygon_coordinates && Data.polygon_coordinates.length >= 3
        ? Data.polygon_coordinates
        : [];

    if (coordsArray.length < 3) {
      SetError("Please draw a delivery polygon boundary on the map (minimum 3 points required).");
      setpopupType("error");
      return;
    }

    const data_to_post = {
      ...Data,
      logo_image: typeof Data.logo_image === "object" ? Data.logo_image?.id : Data.logo_image,
      banner_image: typeof Data.banner_image === "object" ? Data.banner_image?.id : Data.banner_image,
      boundary_type: "polygon",

      polygon_coordinates: coordsArray.map((point) => {
        if (Array.isArray(point)) {
          return {
            lat: Number(point[0]),
            lng: Number(point[1]),
          };
        }
        return {
          lat: Number(point?.lat !== undefined ? point.lat : point?.[0] || 0),
          lng: Number(point?.lng !== undefined ? point.lng : point?.[1] || 0),
        };
      }),
      spike_percentage:
        parseFloat(Data.spike_percentage) > 0
          ? parseFloat(Data.spike_percentage)
          : 0.0,
      slot_duration:
        Data.slot_duration !== undefined && Data.slot_duration !== ""
          ? Number(Data.slot_duration)
          : 0,
    };

    if (Data.express_delivery !== undefined) {
      data_to_post.express_delivery =
        Data.express_delivery === true || Data.express_delivery === "true" ? "true" : "false";
    }
    if (Data.schedule_delivery !== undefined) {
      data_to_post.schedule_delivery =
        Data.schedule_delivery === true || Data.schedule_delivery === "true" ? "true" : "false";
    }
    if (Data.latitude !== undefined && Data.latitude !== "") {
      data_to_post.latitude = Number(Data.latitude);
    }
    if (Data.longitude !== undefined && Data.longitude !== "") {
      data_to_post.longitude = Number(Data.longitude);
    }

    const hasFiles = Object.values(data_to_post).some(
      (val) => val instanceof File || val instanceof Blob
    );
    if (hasFiles) {
      axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
    } else {
      axiosConfig.defaults.headers["Content-Type"] = "application/json";
    }

    if (data_to_post.express_delivery !== "true" && data_to_post.schedule_delivery !== "true") {
      SetError("Please check The delivery option.");
      setpopupType("error");
      return;
    } else if (data_to_post.schedule_delivery === "true" && !data_to_post.slot_duration) {
      SetError("Please mention slot duration");
      setpopupType("error");
      return;
    }

    if (data_to_post.mobileno && data_to_post.mobileno.length < 10) {
      SetError("Please enter valid mobile number");
      setpopupType("error");
      return;
    }

    if (!data_to_post.latitude || !data_to_post.longitude) {
      SetError("Please select location from map to get latitude and longitude");
      setpopupType("error");
      return;
    }

    const latitude = parseFloat(data_to_post.latitude);
    const longitude = parseFloat(data_to_post.longitude);

    // Check if latitude or longitude is NaN
    if (isNaN(latitude) || isNaN(longitude)) {
      SetError(
        "Please enter valid latitude and longitude or select location from map to get latitude and longitude"
      );
      setpopupType("error");
      return;
    }

    // else{
    if (Data.id) {
      axiosConfig
        .patch(`/stores/stores/${Data.id}/`, data_to_post)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          setShow(false);
          setMessage(res.data?.message || "Store updated successfully");
          GetStores();
          SetError("");
        })
        .catch((error) => {
          console.log(error);
          const ErrorData = [];
          ErrorData.push({
            code: error.response?.data?.code || ["null"],
            name: error.response?.data?.name || ["null"],
          });
          console.log(ErrorData[0]);
          if (
            ErrorData[0].code[0] === "priority with this code already exists."
          ) {
            SetError(" code already exists.");
          }
          if (
            ErrorData[0].name[0] === "priority with this name already exists."
          ) {
            SetError("Title already Exists");
          }
          if (error.response?.data?.detail) {
            SetError(error.response.data.detail);
          }
          setpopupType("error");
        });
    } else {
      axiosConfig
        .post(`/stores/stores/`, data_to_post)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          setShow(false);
          setMessage(res.data?.message || "Store added successfully");
          GetStores();
          SetError("");
        })
        .catch((error) => {
          console.log(error);
          SetError(error.response?.data?.detail || "Error adding store");
          setpopupType("error");
        });
    }
    // }
  };

  useEffect(() => {
    GetStores();
  }, [currentPage, RowPerPage]);
  return (
    <>
      <div className="child-sidenav">
        <SettingNavbarComponent />
        <div className="childnav-content">
          <div className="d-flex align-items-center">
            <div className="input-cat-with-icon">
              <span className="icon-product">
                <BiSearch />
              </span>
              <input
                type="text"
                className="input-control"
                placeholder="Search"
                name="search"
                value={search.search}
                onChange={HandleSearch}
              />
            </div>
            <div className="cat-button">
              <div className="btn" onClick={handleAdd}>
                + Add New
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <DataTable
              columns={store_columns}
              data={stores}
              draggableColumns
              pagination
              paginationTotalRows={totalRows}
              paginationPerPage={RowPerPage}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
              paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
              onChangeRowsPerPage={(RowsPerPageChange) =>
                setRowPerPage(RowsPerPageChange)
              }
              onSort={handleSort}
              paginationServer
              fixedHeader
              subHeader
              customStyles={tableCustomStyles}
              progressPending={Loading}
              progressComponent={
                <div className="loader-container">
                  <img
                    src={require("../Components/FormParser/images/loader2.gif")}
                    alt="Loading..."
                  />
                </div>
              }
              subHeaderComponent={
                <input
                  type="text"
                  className="form-control w-25"
                  name="search"
                  value={search.search}
                  onChange={HandleSearch}
                />
              }
            />
          </div>
        </div>
        <Modal
          size="xl"
          show={show}
          onHide={handleClose}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="Loginerror">
              <p>{Error}</p>
            </div>
            {ecommerce_type === "Hyperlocal" ? (
              <FormParser
                modelObject={
                  modalTitle === "Edit Store"
                    ? Masters.StoreManagerHyperlocal
                    : Masters.AddStoreHyperlocal
                }
                formData={formData}
                formSubmit={formSubmit}
                buttonTitle="Save"
              />
            ) : (
              <FormParser
                modelObject={
                  modalTitle === "Edit Store"
                    ? Masters.StoreManager
                    : Masters.AddStore
                }
                formData={formData}
                formSubmit={formSubmit}
                buttonTitle="Save"
              />
            )}
          </Modal.Body>
        </Modal>
        {popupType != "" && (
          <PopupModal
            popupType={popupType}
            Navigation="/dashboard/admin/profile"
            Message={message}
            setMessage={setMessage}
            error={Error}
            setpopupType={setpopupType}
          />
        )}
        {deletePopupType != "" &&
          <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
        }
        {
          AlertDeletePopupType === "success" &&
          (<AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} HandleDelete={HandleDelete} CancelAlerrt={CancelAlerrt} row={RowId} />)
        }
      </div>
    </>
  );
};
export { AdminProfile };
